import { __ } from '@wordpress/i18n';
import { Info } from 'lucide-react';
import { SimpleInput } from '@getdokan/dokan-ui';

const RulePriority = ( { rule, setRule } ) => {
    return (
        <div className="bg-white rounded-lg shadow">
            <div className="p-5 border-b border-[#E9E9E9]">
                <h2 className="text-lg font-bold text-[#25252D]">
                    { __( 'Rule Priority', 'dokan' ) }
                </h2>
            </div>
            <div className="p-5 space-y-2.5">
                <div className="flex items-center gap-2.5">
                    <label
                        htmlFor="quote-rule-order"
                        className="text-sm font-medium text-[#25252D]"
                    >
                        { __( 'Order', 'dokan' ) }
                    </label>
                    <div className="relative group">
                        <Info
                            size={ 16 }
                            className="text-gray-400 cursor-help"
                        />
                        <div className="invisible group-hover:visible absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-64 p-3 bg-gray-900 text-white text-xs rounded shadow-lg z-10">
                            { __(
                                'Order Priority will be 0>1>2>3… Last one in the list will get priority when two (or more) rules have same priority 0,0,0…',
                                'dokan'
                            ) }
                        </div>
                    </div>
                </div>
                <SimpleInput
                    className="focus:outline-0"
                    onChange={ ( e ) =>
                        setRule( ( prev ) => ( {
                            ...prev,
                            rule_priority:
                                parseInt( e.target.value ) || 0,
                        } ) )
                    }
                    input={ {
                        type: 'number',
                        id: 'quote-rule-order',
                        value: rule.rule_priority,
                        placeholder: __( 'Rule order', 'dokan' ),
                    } }
                />
            </div>
        </div>
    );
};

export default RulePriority;
